var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contentPage"},[_vm._v(" 终极健康分析（共"+_vm._s(_vm.totalNumber.count)+"页）P"+_vm._s(_vm.totalNumber.currentPage)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }